import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";

import styles from "./styles.module.css";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  // Merchants arriving from a Shopify-owned surface (the App Store listing, the
  // Apps section of their admin) carry a `shop` param — hand them straight to
  // the embedded app, which authenticates them.
  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return json({});
};

/**
 * Public landing page for the app URL.
 *
 * Deliberately has no shop-domain input. App Store requirement 2.3.1 prohibits
 * asking a merchant to type their myshopify.com domain — installation has to
 * start from a Shopify-owned surface, which then supplies the `shop` param
 * handled in the loader above.
 */
export default function Index() {
  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <h1 className={styles.heading}>ShowPics</h1>
        <p className={styles.text}>
          Turn your Instagram feed into shoppable galleries on your Shopify storefront.
        </p>
        <p className={styles.instructions}>
          Install ShowPics from the Shopify App Store, then open it from the <strong>Apps</strong>{" "}
          section of your Shopify admin.
        </p>
        <ul className={styles.list}>
          <li>
            <strong>Connect your Instagram account</strong>. Link Instagram Business or Creator
            accounts, with tokens refreshed automatically so galleries keep working.
          </li>
          <li>
            <strong>Build a gallery in a few steps</strong>. Pick the posts you want, choose a grid,
            masonry or carousel layout, and style it to match your theme.
          </li>
          <li>
            <strong>Tag products on your posts</strong>. Add product hotspots to any image so
            shoppers can go from a photo straight to the product page.
          </li>
          <li>
            <strong>Add it to your theme</strong>. Galleries are app blocks, so you place them in
            the theme editor — no theme code to edit.
          </li>
        </ul>
      </div>
    </div>
  );
}
